import React from 'react'
import PropTypes from 'prop-types'

import { StyledButton, StyledExternalLink, StyledInternalLink } from './Button.styled'

const Button = (props) => {
  const {
    ariaLabel,
    title,
    children,
    className,
    contactEmail,
    disabled = false,
    href,
    label, 
    iconOnly = false,
    onClick = () => {},
    state,
    to,
    variant,
    type,
    target,
  } = props

  if(contactEmail) {
    return <StyledExternalLink $variant={variant} href={`mailto:${contactEmail}`} target="_blank">{children || label}</StyledExternalLink>
  }

  const Element = to
    ? StyledInternalLink
    : href
    ? StyledExternalLink
    : StyledButton
  return (
    <Element
      aria-label={ariaLabel}
      title={title}
      className={className}
      disabled={disabled}
      href={href}
      onClick={onClick}
      state={state}
      to={to}
      type={type}
      $variant={variant}
      iconOnly={iconOnly}
      target={target}
    >
      {children || label}
    </Element>
  )
}

Button.propTypes = {
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  contactEmail:PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  label: PropTypes.string,
  iconOnly: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string,
  variant: PropTypes.string,
  target: PropTypes.string,
}

export default Button
